import { api } from './client'

// Bài viết + chuyên mục tin tức website (CMS về ERP). Bài đã đăng sửa tiếp
// thì chỉ ghi nháp chờ đăng; bấm "Đăng" mới lên web.

export type ShopPostStatus = 'draft' | 'published'

export interface ShopPostCategory {
    id: string
    slug: string
    label: string
    sort_order: number
    post_count: number
    draft_count: number
    updated_at: string
}

export interface ShopPostCategoryInput {
    label: string
    slug: string
    sort_order: number
}

export interface ShopPostRow {
    id: string
    slug: string
    title: string
    excerpt: string | null
    status: ShopPostStatus
    has_draft: boolean
    featured: boolean
    published_at: string | null
    updated_at: string
    category_slug: string | null
    category_label: string | null
    cover_media_id: string | null
}

export interface ShopPostFields {
    slug: string
    title: string
    excerpt: string | null
    category_id: string | null
    cover_media_id: string | null
    featured: boolean
    content_html: string | null
    seo_title: string | null
    seo_description: string | null
    og_media_id: string | null
    group_ids: string[]
}

export interface ShopContentImage {
    id: string
    url: string
    thumb_url: string
    alt: string
    width: number | null
    height: number | null
}

export interface ShopPostEdit {
    id: string
    status: ShopPostStatus
    has_draft: boolean
    published_at: string | null
    live_slug: string
    version: number
    updated_at: string
    fields: ShopPostFields
    media: Record<string, ShopContentImage>
}

export interface ShopPostInput extends ShopPostFields {
    version?: number
    published_at?: string | null
}

export interface ShopPostListParams {
    q?: string
    status?: ShopPostStatus
    category_id?: string
    page?: number
    per_page?: number
}

export type ShopPostAction = 'publish' | 'unpublish' | 'discard-draft'

export const shopCmsApi = {
    postCategories: () =>
        api.get<ShopPostCategory[]>('/shop-admin/post-categories'),
    createPostCategory: (input: ShopPostCategoryInput) =>
        api.post<ShopPostCategory>('/shop-admin/post-categories', input),
    updatePostCategory: (id: string, input: ShopPostCategoryInput) =>
        api.put<ShopPostCategory>(`/shop-admin/post-categories/${id}`, input),
    deletePostCategory: (id: string) =>
        api.delete<void>(`/shop-admin/post-categories/${id}`),
    posts: (params: ShopPostListParams) =>
        api.get<ShopPostRow[]>('/shop-admin/posts', { params }),
    post: (id: string) => api.get<ShopPostEdit>(`/shop-admin/posts/${id}`),
    createPost: (input: ShopPostInput) =>
        api.post<ShopPostEdit>('/shop-admin/posts', input),
    savePost: (id: string, input: ShopPostInput) =>
        api.put<ShopPostEdit>(`/shop-admin/posts/${id}`, input),
    postAction: (
        id: string,
        action: ShopPostAction,
        input: ShopPostInput | { version: number },
    ) => api.post<ShopPostEdit>(`/shop-admin/posts/${id}/${action}`, input),
    deletePost: (id: string) => api.delete<void>(`/shop-admin/posts/${id}`),
}
